import React from 'react';
import { useDispatch } from 'react-redux';
import { showManageRolesModal } from '../actions/modal.js';
import { resendInvitionToWaitingArea, cancelInvitionToWaitingArea } from '../actions/waitingArea';
import { ContextualMenu, forceCloseContextualMenu } from '../components/shared/contextualMenu/content';

function WaitingAreaUserActionsMenu(props) {
  const dispatch = useDispatch();

  const clickManageRoles = (userId) => {
    dispatch(showManageRolesModal(true));
  };

  const resendInvitation = (user) => {
    dispatch(resendInvitionToWaitingArea(props.waitingArea, user));

    setTimeout(() => {
      forceCloseContextualMenu('.manage-users-waiting-area-container');
    }, 100);
  };

  const cancelnvitation = (user) => {
    dispatch(cancelInvitionToWaitingArea(props.waitingArea, user));

    setTimeout(() => {
      forceCloseContextualMenu('.manage-users-waiting-area-container');
    }, 100);
  };

  return (
    <ContextualMenu
      id={props.selectedUser.id}
      options={[
        {
          title: APP.LANGUAGE.WaitingAreaUserActionMenu.ViewDetails,
          customAction: false,
          show: false,
        },
        {
          title: APP.LANGUAGE.WaitingAreaUserActionMenu.ManageRoles,
          customAction: false,
          show: !props.selectedUser.isEmailOnlyUser,
          action: () => clickManageRoles(props.selectedUser.id),
        },
        {
          title: APP.LANGUAGE.WaitingAreaUserActionMenu.ResendInvite,
          customAction: false,
          show: props.selectedUser.isEmailOnlyUser,
          action: () => resendInvitation(props.selectedUser),
        },
        {
          title: APP.LANGUAGE.WaitingAreaUserActionMenu.CancelInvite,
          customAction: false,
          show: props.selectedUser.isEmailOnlyUser,
          action: () => cancelnvitation(props.selectedUser),
        },
        {
          title: APP.LANGUAGE.WaitingAreaUserActionMenu.Email,
          customAction: false,
          show: false,
        },
        {
          title: APP.LANGUAGE.WaitingAreaUserActionMenu.Remove,
          customAction: false,
          show: false,
        },
      ]}
    />
  );
}

export default WaitingAreaUserActionsMenu;
